import { colors } from 'ui/theme';
import { NotificationStatus } from './types';

export const ORDER_BY_OPTIONS = {
  ContextTimestamp: { displayName: 'Date Updated', filterName: 'ContextTimestamp' },
  CreatedAt: { displayName: 'Date Created', filterName: 'CreatedAt' },
  Level: { displayName: 'Level', filterName: 'Level' },
};

export const STATUS_OPTIONS = {
  unread: 'Unread',
  read: 'Read',
};

export const LEVEL_OPTIONS = {
  warning: 'Warning',
  error: 'Error',
  info: 'Info',
  success: 'Success',
};

export const DEFAULT_FETCH_NOTIFICATIONS_PARAMETERS = {
  orderBy: ORDER_BY_OPTIONS.ContextTimestamp.filterName,
  page: 1,
  pageSize: 10,
  sortDesc: true,
  status: NotificationStatus.UNREAD,
};

export const MESSAGE_COLORS = {
  [LEVEL_OPTIONS.warning]: colors.warning100,
  [LEVEL_OPTIONS.error]: colors.negative100,
  [LEVEL_OPTIONS.success]: colors.positive100,
  [LEVEL_OPTIONS.info]: colors.info100,
};
